// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Offtheshelf[data-v-b9d0e5ba] {\n  color: red;\n}\n.ShoppingCart[data-v-b9d0e5ba] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.ShoppingCart .content[data-v-b9d0e5ba] {\n    width: 1200px;\n    padding-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
